import { Cabinet } from '../entities/Cabinet';
import { Shelf } from '../entities/Shelf';
import { PositionAngle } from '../constants';
import { completeIntermediateShelfFactory, rackFactory } from './factories';
import { doorFactory, drawerFactory } from './componentsFactories';

export function shelfFactory(level = 0, height = 370, cabinet: Cabinet): Shelf {
  return new Shelf(
    level,
    false,
    false,
    [rackFactory(0, height, cabinet.width, cabinet.depth)],
    [
      doorFactory(PositionAngle.FrontRight, height, cabinet.width),
      doorFactory(PositionAngle.FrontLeft, height, cabinet.width),
    ],
    cabinet,
  );
}

export function shelfWithTwoRacksFactory(
  level = 0,
  height = 370,
  cabinet: Cabinet,
): Shelf {
  return new Shelf(
    level,
    false,
    false,
    [
      rackFactory(0, height, cabinet.width, cabinet.depth),
      rackFactory(1, height, cabinet.width, cabinet.depth),
    ],
    [
      doorFactory(PositionAngle.FrontRight, height, cabinet.width),
      doorFactory(PositionAngle.FrontLeft, height, cabinet.width),
    ],
    cabinet,
  );
}

export function shelfWithOneDrawerFactory(
  level = 0,
  height = 270,
  cabinet: Cabinet,
): Shelf {
  return new Shelf(
    level,
    false,
    false,
    [rackFactory(0, height, cabinet.width, cabinet.depth)],
    [],
    cabinet,
    [drawerFactory(270, cabinet.width, cabinet.depth)],
  );
}

export function shelfWithOneIntermediateShelfFactory(
  level = 0,
  height = 370,
  cabinet: Cabinet,
): Shelf {
  return new Shelf(
    level,
    false,
    false,
    [
      rackFactory(0, height, cabinet.width, cabinet.depth),
      rackFactory(1, height, cabinet.width, cabinet.depth),
    ],
    [
      doorFactory(PositionAngle.FrontRight, height, cabinet.width),
      doorFactory(PositionAngle.FrontLeft, height, cabinet.width),
    ],
    cabinet,
    [],
    [completeIntermediateShelfFactory(0, 125, cabinet.width, cabinet.depth)],
  );
}

export function shelfWithTwoIntermediateShelfFactory(
  level = 0,
  height = 370,
  cabinet: Cabinet,
): Shelf {
  return new Shelf(
    level,
    false,
    false,
    [
      rackFactory(0, height, cabinet.width, cabinet.depth),
      rackFactory(1, height, cabinet.width, cabinet.depth),
    ],
    [
      doorFactory(PositionAngle.FrontRight, height, cabinet.width),
      doorFactory(PositionAngle.FrontLeft, height, cabinet.width),
    ],
    cabinet,
    [],
    [
      completeIntermediateShelfFactory(0, 125, cabinet.width, cabinet.depth),
      completeIntermediateShelfFactory(1, 125, cabinet.width, cabinet.depth),
    ],
  );
}
